import axios from "axios";
import { AxiosError } from "axios";
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
import { Action } from "api/action_types/quote";
import { Action as AuthAction } from "api/action_types/authentication";
import { ActionType } from "api/action_types/quote";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { Quote } from "api/types/quote";
import { url_prefix } from "settings";
import { email_quote_url } from "../endpoint";

export const emailQuote = (quote: Quote, pdf: any, send_to_email: string) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {

    const { user } = getState().authentication;

    dispatch({
      type: ActionType.QUOTE_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const blob = await pdf.toBlob();

    const form_data: FormData = new FormData();
    form_data.append('file', blob);

    const url = `${url_prefix}${email_quote_url}/?quote_id=${quote.id}&send_to_email=${send_to_email}`;

    try {
      await axios.post(url, form_data, config);

      dispatch({
        type: ActionType.SEND_QUOTE_SUCCESS
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.QUOTE_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
